export const GUIDED_INTAKE_PROMO_EVENTS = {
  DISMISSED: 'Guided Intake Promo Dismissed',
} as const

/**
 * Fullstory custom events for the Guided Intake funnel, reached through the
 * Segment -> Fullstory destination. Names are fixed by the instrumentation
 * spec: the Fullstory funnels are configured against these exact strings.
 */
export const GUIDED_INTAKE_EVENTS = {
  CONVERSATION_STARTED: 'gi_conversation_started',
  USER_TURN: 'gi_user_turn',
  RESULTS_RENDERED: 'gi_results_rendered',
  ITEM_SELECTED: 'gi_item_selected',
  DRAFT_OR_CREATED: 'gi_draft_or_created',
  CHECKOUT_REDIRECT: 'gi_checkout_redirect',
  ENTRY_POINT_SHOWN: 'gi_entry_point_shown',
  ENTRY_POINT_CLICKED: 'gi_entry_point_clicked',
} as const

export const SMART_SEARCH_EVENTS = {
  RESULTS_RENDERED: 'ss_results_rendered',
  RESULT_CLICKED: 'ss_result_clicked',
} as const

export const A2UI_MCP_APP_ALLOWED_ORIGINS: string[] = [
  'https://dn529vuxi1w26.cloudfront.net',
]

export const A2UI_MCP_APP_LINK_DOMAINS: string[] = [
  'amazon.com',
  'amazon.ca',
  'amazon.com.mx',
  'amazon.com.br',
  'amazon.co.uk',
  'amazon.de',
  'amazon.fr',
  'amazon.it',
  'amazon.es',
  'amazon.nl',
  'amazon.se',
  'amazon.pl',
  'amazon.com.be',
  'amazon.ie',
  'amazon.com.tr',
  'amazon.ae',
  'amazon.sa',
  'amazon.eg',
  'amazon.in',
  'amazon.co.jp',
  'amazon.sg',
  'amazon.com.au',
]

export const ITEM_DETAILS_TIMEOUT_MS = 8000
